{
  "actions": "Acciones",
  "hideButtonLabel": "Mostrar menos",
  "noTags": "Ninguno",
  "showAllButtonLabel": "Mostrar todo ({tagCount, number})"
}
